export const IOF = 0.0738;
export const ADJUST_VALUE = 0.931272;

export const formatPolicyStatus = (status) => PolicyStatus[status] || '';
export const formatProposalStatus = (status) => ProposalStatus[status] || '';
const ProposalStatus = {
  awaiting_inspection: 'Aguardando vistoria',
  awaiting_vistei: 'Aguardando aprovação de fotos',
  awaiting_complementar: 'Aguardando fotos complementares',
  awaiting_registration: 'Aguardando cadastro',
  awaiting_complementar_report: 'Aguardando aprovação das fotos complementares',
  awaiting_payment: 'Aguardando pagamento',
  awaiting_mga_communication: 'Aguardando comunicação de emissão do MGA',
  activated: 'Ativada',
  rejected: 'Rejeitada',
  cancelled: 'Cancelada',
  expired: 'Expirada',
};

const PolicyStatus = {
  active: 'Ativo',
  canceled: 'Cancelado',
  awaiting_cancellation: 'Aguardando cancelamento',
  expired: 'Expirado',
  awaiting_reactive: 'Aguardando reativação',
};

export const PartnerProduct = {
  corporate: 'corporate',
  dealer: 'dealer',
  runoff: 'runOff',
  franchise: 'franquias',
  advisory: 'assessorias',
  enterprise: 'enterprise',
};

export const SEVEN_BRAND = {
  name: 'SEVEN SEGUROS',
  site: 'www.sevenseguros.com.br',
};

export const EMPTY_VALUE = '-';

export const GUARANTOR = {
  socialReason: 'SPLIT RISK SEGURADORA S.A',
  cnpj: '43.505.273/0001-09',
  susepProcess: '15414.625403/2026-19',
  sac: '0800 942 7057',
  ombudsman: '0800 942 7057',
  generalConditions: 'www.splitrisk.com.br',
};

export const hasPermission = (permissions, feature) => {
  const menuIndex = permissions.findIndex((i) => i.feature === feature);
  if (menuIndex === -1) return;
  return permissions[menuIndex].hasPermission;
};

export const partnersInfo = [
  {
    id: 6,
    id_partner: 8,
    id_partner_vistei: 5,
    subdomain: 'enterprise-portal',
    name: 'Seven Franquias',
    document: '36851667000145',
    website: 'https://sevenseguros.com.br/',
    email: 'contato@sevenseguros.com.br',

    theme: {
      primary: '#fab701',
      secondary: '#0000d4',
      ternary: '#ffffff',
      buttonTextColor: '#ffffff',
    },

    logos: {
      full: 'https://splitrisk-corporate.s3.amazonaws.com/36851667000145_Seven_Seguros/logo-full.png',
      fullClear: 'https://splitrisk-corporate.s3.amazonaws.com/36851667000145_Seven_Seguros/logo-full-clear.png',
      small: 'https://splitrisk-corporate.s3.amazonaws.com/36851667000145_Seven_Seguros/logo-small.png',
    },

    comission: {
      allowed_comission_slider: false,
      corporate_partner_comission: 0.5,
      partner_fixed_comission: 0.5,
      min_comission_range: 0,
      max_comission_range: 0,
    },

    splitris_assistance: false,
    is_asaas: false,
    slider_available: true,
  },
  {
    id: 6,
    id_partner: 8,
    id_partner_vistei: 5,
    subdomain: 'seven',
    name: 'Seven Franquias',
    document: '36851667000145',
    website: 'https://sevenseguros.com.br/',
    email: 'contato@sevenseguros.com.br',

    theme: {
      primary: '#fab701',
      secondary: '#0000d4',
      ternary: '#ffffff',
      buttonTextColor: '#ffffff',
    },

    logos: {
      full: 'https://splitrisk-corporate.s3.amazonaws.com/36851667000145_Seven_Seguros/logo-full.png',
      fullClear: 'https://splitrisk-corporate.s3.amazonaws.com/36851667000145_Seven_Seguros/logo-full-clear.png',
      small: 'https://splitrisk-corporate.s3.amazonaws.com/36851667000145_Seven_Seguros/logo-small.png',
    },

    comission: {
      allowed_comission_slider: false,
      corporate_partner_comission: 0.5,
      partner_fixed_comission: 0.5,
      min_comission_range: 0,
      max_comission_range: 0,
    },

    splitris_assistance: false,
    is_asaas: false,
    slider_available: true,
  },
  {
    id: 29,
    id_partner: 31,
    id_partner_vistei: null,
    subdomain: 'sevenseguros',
    name: 'Seven Seguros',
    document: '36851667000145',
    website: 'https://sevenseguros.com.br/',
    email: 'contato@sevenseguros.com.br',
    theme: {
      primary: '#fab701',
      secondary: '#0000d4',
      ternary: '#ffffff',
      buttonTextColor: '#ffffff',
    },
    logos: {
      full: 'https://splitrisk-corporate.s3.amazonaws.com/36851667000145_Seven_Seguros/logo-full.png',
      fullClear: 'https://splitrisk-corporate.s3.amazonaws.com/36851667000145_Seven_Seguros/logo-full-clear.png',
      small: 'https://splitrisk-corporate.s3.amazonaws.com/36851667000145_Seven_Seguros/logo-small.png',
    },
    comission: {
      allowed_comission_slider: false,
      corporate_partner_comission: 0.5,
      partner_fixed_comission: 0.5,
      min_comission_range: 0,
      max_comission_range: 0,
    },
    splitris_assistance: false,
    is_asaas: false,
    slider_available: true,
  },
  {
    id: 17,
    id_partner: 19,
    id_partner_vistei: 5,
    subdomain: 'sevencar',
    name: 'Seven Enterprise',
    document: '36851667000145',
    website: 'https://sevenseguros.com.br/',
    email: 'contato@sevenseguros.com.br',
    theme: {
      primary: '#fab701',
      secondary: '#0000d4',
      ternary: '#ffffff',
      buttonTextColor: '#ffffff',
    },
    logos: {
      full: 'https://splitrisk-corporate.s3.amazonaws.com/36851667000145_Seven_Seguros/logo-full.png',
      fullClear: 'https://splitrisk-corporate.s3.amazonaws.com/36851667000145_Seven_Seguros/logo-full-clear.png',
      small: 'https://splitrisk-corporate.s3.amazonaws.com/36851667000145_Seven_Seguros/logo-small.png',
    },
    comission: {
      allowed_comission_slider: false,
      corporate_partner_comission: 0.5,
      partner_fixed_comission: 0.5,
      min_comission_range: 0,
      max_comission_range: 0,
    },
    splitris_assistance: false,
    is_asaas: false,
    slider_available: true,
  },
];
